import { render } from "./viewEachOrderDetails.vue?vue&type=template&id=06c1fb93"
import script from "./viewEachOrderDetails.vue?vue&type=script&lang=js"
export * from "./viewEachOrderDetails.vue?vue&type=script&lang=js"

import "./viewEachOrderDetails.vue?vue&type=style&index=0&id=06c1fb93&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__